"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _productRulesEngine = require("@cimpress-technology/product-rules-engine");

var _react = _interopRequireWildcard(require("react"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

var _union = _interopRequireDefault(require("lodash/union"));

var _find = _interopRequireDefault(require("lodash/find"));

var _Spinner = _interopRequireDefault(require("@cimpress/react-components/lib/shapes/Spinner"));

var _reactComponents = require("@cimpress/react-components");

var _coam = require("./services/coam");

var _introduction = require("./services/introduction");

var _productPrice = require("./services/productPrice");

var _PricingGridLayout = _interopRequireDefault(require("./PricingGridLayout"));

var _PriceModeToggle = _interopRequireDefault(require("../PriceModeToggle/PriceModeToggle"));

var _PivotLayout = _interopRequireDefault(require("./PivotLayout"));

var _PricingError = _interopRequireDefault(require("./PricingError"));

var _FulfillerSelector = _interopRequireDefault(require("./FulfillerSelector"));

var _shippingCost = require("./services/shippingCost");

var _util = require("./services/util");

var _listPrice = require("./services/listPrice");

var _shippingPrice = require("./services/shippingPrice");

var _customQuantities = require("./services/customQuantities");

var _productCategory = require("./services/productCategory");

var _productionTime = require("../ShippingConfiguration/services/productionTime");

var _priceExplorerUserSettings = require("./services/priceExplorerUserSettings");

var _isFamilyReferenceId = require("./services/isFamilyReferenceId");

var _attributeValues = require("./services/attributeValues");

var _logger = require("../logger");

var _CustomLoadingOverlay = _interopRequireDefault(require("./CustomLoadingOverlay"));

var PricingGrid =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(PricingGrid, _Component);

  function PricingGrid(_props) {
    var _this;

    (0, _classCallCheck2.default)(this, PricingGrid);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PricingGrid).call(this, _props));

    _this.getInitialState = function () {
      return {
        loading: true,
        fulfillers: [],
        selectedFulfiller: {},
        errorMessage: null,
        priceMode: 'total',
        pivoting: false,
        options: [],
        showDropdown: false,
        isQuantityVisible: false,
        defaultQuantity: null,
        pivotedQuantity: null,
        selectedRow: null,
        selectedColumns: [],
        pivotLayoutState: _this.getPivotLayoutState()
      };
    };

    _this.componentDidUpdate = function (prevProps, prevState) {
      var _this$props = _this.props,
          skuData = _this$props.skuData,
          isProduction = _this$props.isProduction,
          includeDefaultQuantities = _this$props.includeDefaultQuantities,
          initialQuantities = _this$props.initialQuantities,
          onGetAccessToken = _this$props.onGetAccessToken;
      var _this$state = _this.state,
          selectedRow = _this$state.selectedRow,
          selectedColumns = _this$state.selectedColumns,
          pivoting = _this$state.pivoting,
          pivotedQuantity = _this$state.pivotedQuantity,
          isQuantityVisible = _this$state.isQuantityVisible;

      if (prevProps.skuData !== skuData && !(0, _isEqual.default)(Object.keys(prevProps.skuData), Object.keys(skuData))) {
        _this.setState(_this.getInitialState(), _this.loadInitialData);
      } else if (prevProps.includeDefaultQuantities !== includeDefaultQuantities || !(0, _isEqual.default)(prevProps.initialQuantities, initialQuantities)) {
        _this.setState({
          quantityBreaks: _this.getInitialQuantities()
        }, function () {
          return _this.calculatePricesAndShipping();
        });
      } else if (!(0, _isEqual.default)(prevProps.skuData, skuData) || prevProps.isProduction !== isProduction || prevProps.onGetAccessToken() !== onGetAccessToken()) {
        _this.calculatePricesAndShipping();
      } else if (!(0, _isEqual.default)(selectedColumns, prevState.selectedColumns) || !(0, _isEqual.default)(selectedRow, prevState.selectedRow) || pivoting !== prevState.pivoting || pivoting && isQuantityVisible && pivotedQuantity !== prevState.pivotedQuantity) {
        if (pivoting && !selectedRow && (0, _util.isEmptyArray)(selectedColumns)) {
          _this.setState({
            rowData: null,
            headers: null
          });
        } else {
          var isRowEqual = (0, _isEqual.default)(selectedRow, prevState.selectedRow);
          var isColumnEqual = (0, _isEqual.default)(selectedColumns[0], prevState.selectedColumns[0]);

          if (!isRowEqual || !isColumnEqual) {
            if (!isRowEqual && isColumnEqual && selectedRow && prevState.selectedRow) {
              var isOrderChanged = _this.isOnlyOrderChanged(selectedRow.selectedValues, prevState.selectedRow.selectedValues);

              if (isOrderChanged) {
                // TODO sort the result by rows
                return;
              }
            } else if (isRowEqual && !isColumnEqual && selectedColumns[0] && prevState.selectedColumns[0]) {
              var _isOrderChanged = _this.isOnlyOrderChanged(selectedColumns[0].selectedValues, prevState.selectedColumns[0].selectedValues);

              if (_isOrderChanged) {
                _this.createHeaders(selectedRow, selectedColumns);

                return;
              }
            }
          }

          _this.setState({
            rowData: null
          }, function () {
            return _this.calculate();
          });
        }
      } else if (!(0, _isEqual.default)(_this.state.shipmentConfiguration, prevState.shipmentConfiguration)) {
        _this.setState({
          loading: false
        });

        _this.cancelShippingPromises();

        _this.fetchShippingValues().then(function (data) {
          return _this.copyShippingData([_this.state.results, data]);
        });
      }
    };

    _this.onShippingSubmit =
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(destinationCountryCode, destinationPostalCode, shippingTime) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setState({
                  errorMessage: null,
                  shipmentConfiguration: {
                    destinationCountryCode: destinationCountryCode,
                    destinationPostalCode: destinationPostalCode,
                    shippingTime: shippingTime
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.onFulfillerSelect = function (fulfiller) {
      _this.setState({
        selectedFulfiller: fulfiller,
        errorMessage: null
      }, function () {
        return _this.calculatePricesAndShipping();
      });
    };

    _this.onQuantityChange = function (quantity) {
      var pivotedQuantity = _this.state.pivotedQuantity;

      if (pivotedQuantity !== quantity) {
        _this.setState({
          pivotedQuantity: quantity
        });
      }
    };

    _this.onQuantityVisibilityChange = function (visible, pivotedQuantity) {
      var isQuantityVisible = _this.state.isQuantityVisible;

      if (isQuantityVisible !== visible) {
        _this.setState({
          isQuantityVisible: visible,
          pivotedQuantity: pivotedQuantity
        });
      }
    };

    _this.onUpdateSelectedRowColumns = function (row, columns) {
      var _this$state2 = _this.state,
          selectedRow = _this$state2.selectedRow,
          selectedColumns = _this$state2.selectedColumns;

      if (!(0, _isEqual.default)(selectedRow, row) || !(0, _isEqual.default)(selectedColumns, columns)) {
        var clonedRow = row ? (0, _util.deepClone)(row) : row;
        var clonedColumns = (0, _util.deepClone)(columns);

        _this.setState({
          selectedRow: clonedRow,
          selectedColumns: clonedColumns
        });
      }
    };

    _this.setPriceMode = function (priceMode) {
      _this.setState({
        priceMode: priceMode
      });
    };

    _this.getInitialQuantities = function (props) {
      var includeDefaultQuantities = props.includeDefaultQuantities,
          initialQuantities = props.initialQuantities;

      if (includeDefaultQuantities) {
        if (initialQuantities && initialQuantities.length) {
          return (0, _sortBy.default)((0, _union.default)(_util.DEFAULT_QUANTITY_BREAKS, initialQuantities));
        }

        return _util.DEFAULT_QUANTITY_BREAKS;
      } else if (initialQuantities && initialQuantities.length) {
        return (0, _sortBy.default)(initialQuantities);
      }

      return [];
    };

    _this.getProductionTime =
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(mcpSku, requiredAttributesWithValues) {
        var onGetAccessToken, actualProductionTime, response;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                onGetAccessToken = _this.props.onGetAccessToken;
                actualProductionTime = (0, _find.default)(requiredAttributesWithValues, {
                  attributeKey: 'Production Time'
                });

                if (!(actualProductionTime && actualProductionTime > 0)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", {
                  actualProductionTime: actualProductionTime,
                  productionTime: Math.ceil(actualProductionTime / 24),
                  productionTimeUnits: 'HH'
                });

              case 4:
                if (!mcpSku) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 7;
                return (0, _productionTime.getProductionTime)(mcpSku, onGetAccessToken).catch(function () {});

              case 7:
                response = _context2.sent;

                if (!response) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return", {
                  actualProductionTime: response.Time,
                  productionTime: (0, _util.calculateDays)(response.Units, response.Time),
                  productionTimeUnits: response.Units
                });

              case 10:
                return _context2.abrupt("return", null);

              case 11:
                return _context2.abrupt("return", null);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function (_x4, _x5) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.getCustomQuantityId = function (productCategoryId) {
      return "PRICEEXPLORER_CUSTOMQUANTITIES_".concat(productCategoryId);
    };

    _this.getErrorMessage = function (error) {
      var errorMessage = error.status && error.statusText ? "".concat(error.status, " ").concat(error.statusText) : 'An Error Occurred';
      var logMessage = error.status && error.statusText ? "".concat(error.status, " ").concat(error.statusText) : "".concat(error.message, " ").concat(error.stack);

      _this.logger.error("Encountered Error, Error Message : ".concat(logMessage), _this.componentName);

      return errorMessage;
    };

    _this.getSellers =
    /*#__PURE__*/
    (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee4() {
      var _this$props2, skuData, onGetAccessToken, isProduction, sku, sellerId;

      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$props2 = _this.props, skuData = _this$props2.skuData, onGetAccessToken = _this$props2.onGetAccessToken, isProduction = _this$props2.isProduction;

              if (!_this.isSingleSkuEnvironment) {
                _context4.next = 5;
                break;
              }

              sku = Object.keys(skuData)[0];
              sellerId = skuData[sku].sellerId;
              return _context4.abrupt("return", (0, _productPrice.getSellersForSku)(sku, onGetAccessToken, isProduction, sellerId).then(
              /*#__PURE__*/
              function () {
                var _ref4 = (0, _asyncToGenerator2.default)(
                /*#__PURE__*/
                _regenerator.default.mark(function _callee3(sellers) {
                  var defaultSeller, selectedFulfiller;
                  return _regenerator.default.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          defaultSeller = sellerId ? sellers.find(function (seller) {
                            return seller.sellerId === sellerId;
                          }) : null;
                          selectedFulfiller = defaultSeller || sellers[0];

                          _this.setState({
                            fulfillers: sellers,
                            selectedFulfiller: selectedFulfiller
                          });

                          return _context3.abrupt("return", _this.calculate());

                        case 4:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, this);
                }));

                return function (_x6) {
                  return _ref4.apply(this, arguments);
                };
              }()).catch(function (error) {
                if (!error.isCanceled) {
                  _this.setError(_this.createError('Error', _this.getErrorMessage(error), 'Error'));
                }
              }));

            case 5:
              return _context4.abrupt("return", _this.calculate());

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    _this.getShippingCostForEachQuantity =
    /*#__PURE__*/
    function () {
      var _ref5 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(mcpSku, quantity, shippingConfiguration, businessDaysToDelivery, onGetAccessToken) {
        var costRequest;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                costRequest = {
                  attributeSelections: [{
                    class: 'Order',
                    attributeKey: 'Quantity',
                    attributeValue: quantity
                  }],
                  mcpSku: mcpSku,
                  destinationCountryCode: shippingConfiguration.destinationCountryCode,
                  destinationPostalCode: shippingConfiguration.destinationPostalCode,
                  businessDaysToDelivery: businessDaysToDelivery
                };
                return _context5.abrupt("return", (0, _shippingCost.getShippingCost)(costRequest, onGetAccessToken).catch(function (ex) {
                  _this.logger.error("Unable to retrieve shipping cost following is the error [".concat(ex, "]"), _this.componentName);
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      return function (_x7, _x8, _x9, _x10, _x11) {
        return _ref5.apply(this, arguments);
      };
    }();

    _this.getShippingPrice =
    /*#__PURE__*/
    function () {
      var _ref6 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(sku, sellerId, productionTime, productionTimeUnits) {
        var _this$props3, onGetAccessToken, skuData, listPrice, pack, priceModelId;

        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this$props3 = _this.props, onGetAccessToken = _this$props3.onGetAccessToken, skuData = _this$props3.skuData;
                _context6.next = 3;
                return (0, _listPrice.getListPrice)(sellerId, onGetAccessToken).catch(function () {
                  return null;
                });

              case 3:
                listPrice = _context6.sent;
                pack = _this.fetchPackDefinitions(skuData[sku].resolvedAttributes);

                if (!(!listPrice || !pack)) {
                  _context6.next = 7;
                  break;
                }

                return _context6.abrupt("return", null);

              case 7:
                priceModelId = listPrice[0] ? listPrice[0].priceModelId : null;
                return _context6.abrupt("return", _this.prepareInputForShippingPrice(priceModelId, pack.quantity, pack.weight.value, pack.weight.unit, productionTime, productionTimeUnits));

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      return function (_x12, _x13, _x14, _x15) {
        return _ref6.apply(this, arguments);
      };
    }();

    _this.getCustomQuantity =
    /*#__PURE__*/
    function () {
      var _ref7 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(sku) {
        var onGetAccessToken, productCategoryId, customQuantities;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                onGetAccessToken = _this.props.onGetAccessToken;
                _context7.next = 3;
                return _this.getProductCategoryId(sku, onGetAccessToken, false);

              case 3:
                productCategoryId = _context7.sent;

                if (!productCategoryId) {
                  _context7.next = 10;
                  break;
                }

                _context7.next = 7;
                return (0, _customQuantities.getCustomSettings)(_this.getCustomQuantityId(productCategoryId), onGetAccessToken);

              case 7:
                customQuantities = _context7.sent;

                if (!(customQuantities && customQuantities.quantities)) {
                  _context7.next = 10;
                  break;
                }

                return _context7.abrupt("return", customQuantities.quantities);

              case 10:
                return _context7.abrupt("return", null);

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      return function (_x16) {
        return _ref7.apply(this, arguments);
      };
    }();

    _this.setStateToNotifyUserOnce = function () {
      if (_this.isSingleSkuEnvironment) {
        var priceExplorerUserSettings = _this.state.priceExplorerUserSettings;

        if (!priceExplorerUserSettings.isUserNotifiedOnQuantityChange && priceExplorerUserSettings.isUserNotifiedOnQuantityChange !== true) {
          priceExplorerUserSettings.isUserNotifiedOnQuantityChange = false;

          _this.setState({
            priceExplorerUserSettings: priceExplorerUserSettings
          });
        }
      }
    };

    _this.getAllAttributeValues =
    /*#__PURE__*/
    (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee8() {
      var _this$props4, onGetAccessToken, skuData, promises;

      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _this$props4 = _this.props, onGetAccessToken = _this$props4.onGetAccessToken, skuData = _this$props4.skuData;
              promises = [];
              Object.keys(skuData).forEach(function (sku) {
                if (!_this.ruleSetInfoPerSku[sku]) {
                  promises.push((0, _attributeValues.getAllAttributeValues)(sku, onGetAccessToken));
                }
              });

              if ((0, _util.isEmptyArray)(promises)) {
                _context8.next = 5;
                break;
              }

              return _context8.abrupt("return", Promise.all(promises).then(function (combinedResults) {
                if (combinedResults && combinedResults.length) {
                  combinedResults.forEach(function (result) {
                    Object.keys(result).forEach(function (sku) {
                      _this.ruleSetInfoPerSku[sku] = result[sku];
                    });
                  });
                }
              }));

            case 5:
              return _context8.abrupt("return", null);

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    _this.setError = function (errorMessage) {
      if (_this.isSingleSkuEnvironment) {
        var onError = _this.props.onError;
        onError && onError();

        _this.setState({
          loading: false,
          errorMessage: errorMessage
        });
      }
    };

    _this.getSelectVariantMessage =
    /*#__PURE__*/
    function () {
      var _ref9 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(sku) {
        var _this$props5, onGetAccessToken, selectVariant, errorMessage;

        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this$props5 = _this.props, onGetAccessToken = _this$props5.onGetAccessToken, selectVariant = _this$props5.selectVariant;
                errorMessage = null;
                _context9.next = 4;
                return (0, _isFamilyReferenceId.isFamilyReferenceId)(sku, onGetAccessToken);

              case 4:
                if (!_context9.sent) {
                  _context9.next = 6;
                  break;
                }

                if (!_this.isSingleSkuEnvironment) {
                  if (selectVariant) {
                    errorMessage = _this.createError(_react.default.createElement("div", null, _react.default.createElement("a", {
                      onClick: function onClick() {
                        return selectVariant(sku);
                      }
                    }, "Select Variant")), 'Select Attributes to resolve the sku.', 'Error');
                  } else {
                    errorMessage = _this.createError('Select Variant', 'Select Attributes to resolve the sku.', 'Error');
                  }
                } else {
                  errorMessage = _this.createError('INVALID ID', 'Provided Id is a family reference id and not mcpSku id', 'Error');

                  _this.setState({
                    loading: false,
                    errorMessage: errorMessage
                  });

                  _this.logger.error("Provided Id [".concat(sku, "] is a family reference id and not mcpSku id"), _this.componentName);
                }

              case 6:
                return _context9.abrupt("return", errorMessage);

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      return function (_x17) {
        return _ref9.apply(this, arguments);
      };
    }();

    _this.setQuantitiesInOptions =
    /*#__PURE__*/
    (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee10() {
      var _this$state3, options, quantityBreaks, quantity;

      return _regenerator.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _this$state3 = _this.state, options = _this$state3.options, quantityBreaks = _this$state3.quantityBreaks;

              if (!(0, _util.isEmptyArray)(options) && !(0, _util.isEmptyArray)(quantityBreaks)) {
                quantity = options.find(function (option) {
                  return option.key.toLowerCase() === 'quantity';
                });

                if (quantity) {
                  quantity.defaults = quantityBreaks;
                }
              }

              _this.setState({
                options: options
              });

            case 3:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    _this.getQuantityInAttributesOrMoq = function () {
      var defaultQuantity = _this.state.defaultQuantity;
      var pivotingToggleDisabled = _this.state.pivotingToggleDisabled;

      if (!defaultQuantity && !pivotingToggleDisabled) {
        var skuData = _this.props.skuData;
        var sku = Object.keys(skuData)[0];

        if (sku) {
          if (_this.quantityInAttributesPerSku && _this.quantityInAttributesPerSku[sku]) {
            return _this.quantityInAttributesPerSku[sku];
          } else if (_this.ruleSetInfoPerSku && _this.ruleSetInfoPerSku[sku]) {
            return _this.ruleSetInfoPerSku[sku].moq;
          }
        }
      }

      return defaultQuantity;
    };

    _this.getQuantityInAttributes = function (sku) {
      var pivotingToggleDisabled = _this.state.pivotingToggleDisabled;

      if (!pivotingToggleDisabled && sku) {
        if (_this.quantityInAttributesPerSku && _this.quantityInAttributesPerSku[sku]) {
          return _this.quantityInAttributesPerSku[sku];
        } else if (_this.ruleSetInfoPerSku && _this.ruleSetInfoPerSku[sku]) {
          return _this.ruleSetInfoPerSku[sku].moq;
        }
      }

      return null;
    };

    _this.getPivotLayoutState = function () {
      return {
        attributesOriginalList: [],
        attributesDraggableList: [],
        attributeFilterArray: [],
        showQuantity: false,
        selectedRowChips: [],
        selectedColumnChips: [],
        selectedQuantity: null,
        selectedAttributeInFilter: undefined,
        selectedAttributeValues: undefined,
        inputRangeValue: undefined,
        inputListValue: undefined,
        maxSelectedRowsExceeded: null,
        maxSelectedColumnsExceeded: null,
        panelExpanded: true,
        listValuesHelpText: null,
        selectedValuesHelpText: null,
        inputRangeStyle: null,
        initialize: true,
        selected: null,
        dropdownOptions: [],
        defaultColDef: {
          cellClass: 'defaultCellStyle',
          resizable: true,
          filter: true
        },
        frameworkComponents: {
          customLoadingOverlay: _CustomLoadingOverlay.default
        },
        loadingOverlayComponent: 'customLoadingOverlay',
        columnArray: [],
        rowData: null,
        isRowSelected: false,
        isColumnSelected: false
      };
    };

    _this.getRequiredAttributes = function (sku) {
      var skuData = _this.props.skuData;
      var _skuData$sku = skuData[sku],
          displayedAttributes = _skuData$sku.displayedAttributes,
          requiredAttributesWithValues = _skuData$sku.requiredAttributesWithValues;
      var requiredAttributes = [];
      var ruleSet;
      var requiredInputs;

      if (_this.ruleSetInfoPerSku[sku] && _this.ruleSetInfoPerSku[sku].ruleSet && _this.ruleSetInfoPerSku[sku].requiredInputs) {
        var _this$ruleSetInfoPerS = _this.ruleSetInfoPerSku[sku];
        ruleSet = _this$ruleSetInfoPerS.ruleSet;
        requiredInputs = _this$ruleSetInfoPerS.requiredInputs;
      }

      var normalizedRequiredAttributes = {};
      var normalizedDisplayAttributes = {};
      var normalizedRuleset = {};
      var normalizedRequiredInputs = {};

      if (displayedAttributes && Object.keys(displayedAttributes).length && ruleSet && ruleSet.whiteList) {
        Object.keys(displayedAttributes).forEach(function (key) {
          normalizedDisplayAttributes[key.toLowerCase()] = displayedAttributes[key];
        });
        requiredAttributesWithValues.forEach(function (item) {
          normalizedRequiredAttributes[item.attributeKey.toLowerCase()] = item.attributeValue;
        });
        ruleSet.whiteList.forEach(function (input) {
          normalizedRuleset[input.attributeKey.toLowerCase()] = input.class;
        });
        requiredInputs.forEach(function (input) {
          normalizedRequiredInputs[input.name.toLowerCase()] = input.scope;
        });
        Object.keys(displayedAttributes).forEach(function (attributeKey) {
          var key = attributeKey.toLowerCase();
          var attributeValue = normalizedRequiredAttributes[key] ? normalizedRequiredAttributes[key] : normalizedDisplayAttributes[key];
          var classValue = normalizedRuleset[key] ? normalizedRuleset[key] : normalizedRequiredInputs[key];
          requiredAttributes.push({
            attributeKey: attributeKey,
            attributeValue: attributeValue,
            class: classValue
          });
        });
      }

      return requiredAttributes;
    };

    _this.isOnlyOrderChanged = function (oldArray, newArray) {
      if (!oldArray || !newArray) {
        return false;
      }

      if (oldArray.length !== newArray.length) {
        return false;
      }

      var result = true;
      var map = {};
      oldArray.forEach(function (item) {
        map[item] = 1;
      });

      for (var i = 0; i < newArray.length; i += 1) {
        var item = newArray[i];

        if (!map[item]) {
          result = false;
        }
      }

      return result;
    };

    _this.skuProductionTime = {};
    _this.ruleSetInfoPerSku = {};
    _this.contractsPerSku = {};
    _this.listPriceModelsPerSku = {};
    _this.quantityInAttributesPerSku = {};
    _this.requiredAttributesPerSku = {};
    _this.calculateShippingValues =
    /*#__PURE__*/
    (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee11() {
      var promises, skuData;
      return _regenerator.default.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              promises = [];
              skuData = _this.props.skuData;
              Object.keys(skuData).map(function (key) {
                return promises.push(_this.fetchShippingValue(key, skuData[key].sellerId));
              });
              _this.cancelableShippingPromise = (0, _util.makeCancelable)(Promise.all(promises));
              return _context11.abrupt("return", _this.cancelableShippingPromise.promise);

            case 5:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    _this.fetchPackDefinitions = function (resolvedAttributes) {
      var quantity = resolvedAttributes.find(function (each) {
        return each.attributeKey === 'Shippable Pack Quantity';
      });
      var weight = resolvedAttributes.find(function (each) {
        return each.attributeKey === 'Shippable Pack Weight';
      });

      if (quantity && weight) {
        var pack = {
          quantity: quantity.attributeValue,
          weight: {
            value: weight.attributeValue,
            unit: weight.unitOfMeasure
          }
        };
        return pack;
      }

      return null;
    };

    _this.createError = function (shortMessage, detailedMessage, type) {
      return {
        error: {
          shortMessage: shortMessage,
          detailedMessage: detailedMessage,
          type: type
        }
      };
    };

    _this.isSingleSkuEnvironment = true;
    _this.productCategoryIds = {};
    _this.loadInitialData =
    /*#__PURE__*/
    (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee12() {
      return _regenerator.default.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _this.getAllAttributeValues().then(function () {
                return _this.createOptions();
              }).then(_this.populatePricingGrid);

              _this.populatePriceExplorerUserSettings().then(function (priceExplorerUserSettings) {
                var statePriceExplorerUserSettings = priceExplorerUserSettings || {};

                _this.setState({
                  priceExplorerUserSettings: statePriceExplorerUserSettings
                });
              });

            case 2:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));
    _this.populatePriceExplorerUserSettings =
    /*#__PURE__*/
    (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee13() {
      var onGetAccessToken, priceExplorerUserSettings;
      return _regenerator.default.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              onGetAccessToken = _this.props.onGetAccessToken;
              _context13.prev = 1;
              _context13.next = 4;
              return (0, _priceExplorerUserSettings.getPriceExplorerUserSettings)((0, _priceExplorerUserSettings.getPriceExplorerUserSettingsID)(), onGetAccessToken);

            case 4:
              priceExplorerUserSettings = _context13.sent;
              return _context13.abrupt("return", priceExplorerUserSettings || null);

            case 8:
              _context13.prev = 8;
              _context13.t0 = _context13["catch"](1); // First time we invoke getPriceExplorerUserSettings for any user, we will get an exception
              // We are swallowing the exception here.

              _this.logger.error("Unable to populate priceExplorerUserSettings following is the error [".concat(_context13.t0, "]"), _this.componentName);

            case 11:
              return _context13.abrupt("return", null);

            case 12:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this, [[1, 8]]);
    }));

    _this.userHasBeenNotifiedOfQuantityChange = function () {
      var onGetAccessToken = _this.props.onGetAccessToken;
      var priceExplorerUserSettings = _this.state.priceExplorerUserSettings;
      priceExplorerUserSettings.isUserNotifiedOnQuantityChange = true;

      _this.setState({
        priceExplorerUserSettings: priceExplorerUserSettings
      });

      (0, _priceExplorerUserSettings.setPriceExplorerUserSettings)((0, _priceExplorerUserSettings.getPriceExplorerUserSettingsID)(), priceExplorerUserSettings, onGetAccessToken);
    };

    _this.populateQuantities =
    /*#__PURE__*/
    (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee14() {
      var promises, finalQuantities;
      return _regenerator.default.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              promises = [];
              Object.keys(_this.props.skuData).forEach(function (sku) {
                promises.push(_this.getCustomQuantity(sku));
              });
              _context14.next = 5;
              return (0, _util.getAllCustomQuantities)(promises);

            case 5:
              finalQuantities = _context14.sent;
              return _context14.abrupt("return", finalQuantities && finalQuantities.length > 0 ? finalQuantities.sort(function (a, b) {
                return a - b;
              } // Sorting in increasing order
              ) : _this.getInitialQuantities());

            case 9:
              _context14.prev = 9;
              _context14.t0 = _context14["catch"](0); // First time we invoke getCustomSettings for any sku, we will get an exception
              // We are swallowing the exception here.

              _this.logger.error("Unable to populate quantities following is the error [".concat(_context14.t0, "]"), _this.componentName);

            case 12:
              return _context14.abrupt("return", _this.getInitialQuantities());

            case 13:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this, [[0, 9]]);
    }));

    _this.prepareInputForShippingPrice =
    /*#__PURE__*/
    function () {
      var _ref15 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee16(priceModelId, packQuantity, packWeightvalue, packWeightUnits, productionTime, productionTimeUnits) {
        var _this$state4, quantityBreaks, shipmentConfiguration, onGetAccessToken, arrayofGetShippingPrice;

        return _regenerator.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _this$state4 = _this.state, quantityBreaks = _this$state4.quantityBreaks, shipmentConfiguration = _this$state4.shipmentConfiguration;
                onGetAccessToken = _this.props.onGetAccessToken;
                arrayofGetShippingPrice = quantityBreaks.map(
                /*#__PURE__*/
                function () {
                  var _ref16 = (0, _asyncToGenerator2.default)(
                  /*#__PURE__*/
                  _regenerator.default.mark(function _callee15(quantity) {
                    var input, inputSelections, noOfPack;
                    return _regenerator.default.wrap(function _callee15$(_context15) {
                      while (1) {
                        switch (_context15.prev = _context15.next) {
                          case 0:
                            input = {};
                            inputSelections = [];
                            noOfPack = quantity / packQuantity;
                            inputSelections.push(_this.createScope('pack', 'Shippable Pack Weight', packWeightvalue));
                            inputSelections.push(_this.createScope('pack', 'Shippable Pack Quantity', packQuantity));
                            inputSelections.push(_this.createScope('order', 'quantity', quantity));
                            inputSelections.push(_this.createScope('fulfillment', 'productiontime', productionTime));
                            inputSelections.push(_this.createScope('fulfillment', 'productiontimeunits', productionTimeUnits));
                            inputSelections.push(_this.createScope('shipment', 'weightunits', packWeightUnits));
                            inputSelections.push(_this.createScope('shipment', 'weight', noOfPack * packWeightvalue));
                            inputSelections.push(_this.createScope('destination', 'country', shipmentConfiguration.destinationCountryCode));
                            input.InputSelections = inputSelections;
                            return _context15.abrupt("return", (0, _shippingPrice.getShippingPrice)(priceModelId, JSON.stringify(input), onGetAccessToken).catch(function () {
                              return null;
                            }));

                          case 13:
                          case "end":
                            return _context15.stop();
                        }
                      }
                    }, _callee15, this);
                  }));

                  return function (_x24) {
                    return _ref16.apply(this, arguments);
                  };
                }());
                return _context16.abrupt("return", Promise.all(arrayofGetShippingPrice));

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      return function (_x18, _x19, _x20, _x21, _x22, _x23) {
        return _ref15.apply(this, arguments);
      };
    }();

    _this.createScope = function (scope, name, value) {
      return {
        Scope: scope,
        Name: name,
        Value: value
      };
    };

    _this.copyShippingData =
    /*#__PURE__*/
    function () {
      var _ref17 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee17(combinedResults) {
        var _combinedResults, results, data, shippingPrices;

        return _regenerator.default.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _combinedResults = (0, _slicedToArray2.default)(combinedResults, 2), results = _combinedResults[0], data = _combinedResults[1];
                shippingPrices = {};

                if (!((0, _util.isEmptyArray)(results) || (0, _util.isEmptyArray)(data))) {
                  _context17.next = 4;
                  break;
                }

                return _context17.abrupt("return", null);

              case 4:
                // converting data (array) into shippingPrices which is a map
                data.forEach(function (item) {
                  if (item !== null) {
                    var key = Object.keys(item)[0];
                    shippingPrices[key] = item[key];
                  }
                });
                results.forEach(function (result) {
                  var values = Object.values(result.data);
                  values.forEach(function (value) {
                    var sku = value.mcpSku;
                    var shippingPrice = shippingPrices[sku];

                    if (shippingPrice) {
                      var currency = null;

                      if (shippingPrice.errorMessage) {
                        value.shippingErrorMessage = shippingPrice.errorMessage;
                      }

                      if (shippingPrice.note) {
                        value.shippingNote = shippingPrice.note;
                      }

                      value.quantityBreaks.forEach(function (quantityBreak) {
                        var quantity = quantityBreak.quantity;

                        if (shippingPrice[quantity]) {
                          quantityBreak.shipping = shippingPrice[quantity].amount;

                          if (!currency) {
                            currency = shippingPrice[quantity].currency;
                          }
                        }
                      });
                      value.shippingCurrency = currency;
                    }
                  });
                });

                _this.setState({
                  loading: false,
                  results: results
                });

                return _context17.abrupt("return", null);

              case 8:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      return function (_x25) {
        return _ref17.apply(this, arguments);
      };
    }();

    _this.removeShippingFromResults = function () {
      var results = _this.state.results;

      if (results) {
        results.forEach(function (result) {
          if (result && result.data) {
            Object.values(result.data).forEach(function (value) {
              value.quantityBreaks.forEach(function (quantityBreak) {
                quantityBreak.shipping = null;
              });
            });
          }
        });
        results.forEach(function (result) {
          if (result.data) {
            Object.values(result.data).forEach(function (value) {
              if (value.shippingErrorMessage) {
                value.shippingErrorMessage = null;
              }

              if (value.shippingNote) {
                value.shippingNote = null;
              }
            });
          }
        });

        _this.setState({
          results: results
        });
      }
    };

    _this.fetchShippingValues =
    /*#__PURE__*/
    (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee18() {
      var shipmentConfiguration;
      return _regenerator.default.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              shipmentConfiguration = _this.state.shipmentConfiguration;

              if (!(shipmentConfiguration && shipmentConfiguration.destinationCountryCode && shipmentConfiguration.destinationPostalCode && shipmentConfiguration.shippingTime)) {
                _context18.next = 4;
                break;
              }

              _this.setState({
                loading: true
              });

              return _context18.abrupt("return", _this.calculateShippingValues());

            case 4:
              _this.cancelShippingPromises();

              _this.removeShippingFromResults();

              return _context18.abrupt("return", null);

            case 7:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, this);
    }));

    _this.fetchShippingValue =
    /*#__PURE__*/
    function () {
      var _ref19 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee20(sku, sellerId) {
        var onGetAccessToken, _this$state5, shipmentConfiguration, quantityBreaks, shippingTime, _this$skuProductionTi, productionTime, productionTimeUnits, businessDaysToDelivery, data, shippingPricePromise, arrayOfPromises;

        return _regenerator.default.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                onGetAccessToken = _this.props.onGetAccessToken;
                _this$state5 = _this.state, shipmentConfiguration = _this$state5.shipmentConfiguration, quantityBreaks = _this$state5.quantityBreaks;
                shippingTime = shipmentConfiguration.shippingTime;

                if (_this.skuProductionTime[sku]) {
                  _context20.next = 7;
                  break;
                }

                _context20.next = 6;
                return _this.getProductionTime(sku, _this.props.skuData[sku].requiredAttributesWithValues);

              case 6:
                _this.skuProductionTime[sku] = _context20.sent;

              case 7:
                if (_this.skuProductionTime[sku]) {
                  _context20.next = 9;
                  break;
                }

                return _context20.abrupt("return", null);

              case 9:
                _this$skuProductionTi = _this.skuProductionTime[sku], productionTime = _this$skuProductionTi.productionTime, productionTimeUnits = _this$skuProductionTi.productionTimeUnits;
                businessDaysToDelivery = shippingTime - productionTime >= 0 ? shippingTime - productionTime : null;

                if (businessDaysToDelivery) {
                  _context20.next = 15;
                  break;
                }

                data = {};
                data.errorMessage = "Shipping Time should be more than Production Time of the , Production Time : ".concat(productionTime);
                return _context20.abrupt("return", (0, _defineProperty2.default)({}, sku, data));

              case 15:
                shippingPricePromise = _this.getShippingPrice(sku, sellerId, productionTime, productionTimeUnits);
                arrayOfPromises = quantityBreaks.map(
                /*#__PURE__*/
                function () {
                  var _ref21 = (0, _asyncToGenerator2.default)(
                  /*#__PURE__*/
                  _regenerator.default.mark(function _callee19(element) {
                    return _regenerator.default.wrap(function _callee19$(_context19) {
                      while (1) {
                        switch (_context19.prev = _context19.next) {
                          case 0:
                            return _context19.abrupt("return", _this.getShippingCostForEachQuantity(sku, element, shipmentConfiguration, businessDaysToDelivery, onGetAccessToken));

                          case 1:
                          case "end":
                            return _context19.stop();
                        }
                      }
                    }, _callee19, this);
                  }));

                  return function (_x28) {
                    return _ref21.apply(this, arguments);
                  };
                }());
                return _context20.abrupt("return", Promise.all([shippingPricePromise].concat((0, _toConsumableArray2.default)(arrayOfPromises))).then(function (allResults) {
                  var _allResults = (0, _toArray2.default)(allResults),
                      shippingPrice = _allResults[0],
                      shippingCost = _allResults.slice(1);

                  var data = (0, _util.buildShippingData)(shippingCost, shippingPrice, quantityBreaks);

                  var errorMessage = _this.displayErrorMessage(shippingCost);

                  if (errorMessage) {
                    if (errorMessage.errorMessage) {
                      data.errorMessage = errorMessage.errorMessage;
                    }

                    if (errorMessage.note) {
                      data.note = errorMessage.note;
                    }
                  }

                  return (0, _defineProperty2.default)({}, sku, data);
                }));

              case 18:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      return function (_x26, _x27) {
        return _ref19.apply(this, arguments);
      };
    }();

    _this.calculate =
    /*#__PURE__*/
    (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee21() {
      var _this$props6, onGetAccessToken, isProduction, skuData, _this$state6, selectedFulfiller, fulfillers, pivoting, options, _this$state7, quantityBreaks, selectedRow, selectedColumns, defaultQuantity, fulfillerId, rowData, quantity, ruleSetNotFound, keys, i, numberOfQuantities, _i, sku, requiredAttributes, hasQuantity, attribute, _quantity, promises;

      return _regenerator.default.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              if (_this.cancelablePricingPromise) {
                _this.cancelablePricingPromise.cancel();

                _this.cancelablePricingPromise = null;
              }

              _this$props6 = _this.props, onGetAccessToken = _this$props6.onGetAccessToken, isProduction = _this$props6.isProduction, skuData = _this$props6.skuData;
              _this$state6 = _this.state, selectedFulfiller = _this$state6.selectedFulfiller, fulfillers = _this$state6.fulfillers, pivoting = _this$state6.pivoting, options = _this$state6.options;
              _this$state7 = _this.state, quantityBreaks = _this$state7.quantityBreaks, selectedRow = _this$state7.selectedRow, selectedColumns = _this$state7.selectedColumns, defaultQuantity = _this$state7.defaultQuantity;

              if (!(0, _util.isEmptyArray)(quantityBreaks)) {
                _context21.next = 6;
                break;
              }

              return _context21.abrupt("return", null);

            case 6:
              if (!_this.isSingleSkuEnvironment) {
                _context21.next = 11;
                break;
              }

              fulfillerId = selectedFulfiller && selectedFulfiller.value ? selectedFulfiller.value : null;

              if (!(fulfillerId && !fulfillers.find(function (fulfiller) {
                return fulfiller.value === fulfillerId;
              }))) {
                _context21.next = 11;
                break;
              }

              _this.logger.error("The selected seller [".concat(fulfillerId, "] has not configured pricing for this sku [").concat(skuData, "].  Contact the seller for more information."), _this.componentName);

              return _context21.abrupt("return", _this.setState({
                errorMessage: _this.createError('Error', "The selected seller has not configured pricing for this sku.  Contact the seller for more information.", 'Error')
              }));

            case 11:
              if (!(pivoting && !selectedRow && (0, _util.isEmptyArray)(selectedColumns))) {
                _context21.next = 13;
                break;
              }

              return _context21.abrupt("return", null);

            case 13:
              if (pivoting) {
                rowData = _this.state.rowData;

                if (rowData) {
                  _this.setState({
                    rowData: null
                  });
                }

                _this.createHeaders(selectedRow, selectedColumns);

                if (options) {
                  quantity = options.find(function (item) {
                    return item.key.toLowerCase() === 'quantity';
                  });

                  if (quantity && quantity.selectedValues) {
                    quantityBreaks = quantity.selectedValues;
                  }
                }
              } else {
                _this.setState({
                  loading: true,
                  errorMessage: null
                });

                selectedRow = {
                  key: 'Quantity',
                  class: 'order',
                  values: quantityBreaks
                };
                selectedColumns = null;
              }

              ruleSetNotFound = false;
              keys = Object.keys(skuData);
              i = 0;

            case 17:
              if (!(i < keys.length)) {
                _context21.next = 24;
                break;
              }

              if (_this.ruleSetInfoPerSku[keys[i]]) {
                _context21.next = 21;
                break;
              }

              ruleSetNotFound = true;
              return _context21.abrupt("break", 24);

            case 21:
              i += 1;
              _context21.next = 17;
              break;

            case 24:
              if (ruleSetNotFound) {
                _this.getAllAttributeValues();
              }

              numberOfQuantities = quantityBreaks.length;

              for (_i = 0; _i < keys.length; _i += 1) {
                sku = keys[_i];
                requiredAttributes = _this.getRequiredAttributes(sku);
                _this.requiredAttributesPerSku[sku] = requiredAttributes;
                hasQuantity = false;

                if (!(0, _util.isEmptyArray)(requiredAttributes)) {
                  attribute = requiredAttributes.find(function (item) {
                    return item.attributeKey.toLowerCase() === 'quantity';
                  });

                  if (attribute) {
                    // Pricing requires quantity as an integer, so parse it before sending forward.
                    _quantity = parseInt(attribute.attributeValue, 10);
                    attribute.attributeValue = _quantity;
                    hasQuantity = true;
                    _this.quantityInAttributesPerSku[sku] = _quantity;

                    if (!defaultQuantity) {
                      defaultQuantity = _quantity;

                      _this.setState({
                        defaultQuantity: defaultQuantity
                      });
                    } // If the quantity from attributes is not present in quantity breaks, add them


                    if (!quantityBreaks.includes(_quantity)) {
                      quantityBreaks.push(_quantity);
                    }
                  }
                }

                if (!hasQuantity) {
                  _this.quantityInAttributesPerSku[sku] = null;
                }
              } // If quantities from attributes have been added to quantity breaks, sort them


              if (numberOfQuantities < quantityBreaks.length) {
                quantityBreaks = quantityBreaks.sort(function (a, b) {
                  return a - b;
                });

                _this.setState({
                  quantityBreaks: quantityBreaks
                }, function () {
                  return _this.saveCustomQuantities();
                });
              }

              promises = Object.keys(skuData).map(function (sku) {
                return _this.calculatePriceList(onGetAccessToken, isProduction, sku, quantityBreaks, defaultQuantity, _this.requiredAttributesPerSku[sku], skuData[sku].sellerId, selectedRow, selectedColumns, pivoting);
              });
              _this.cancelablePricingPromise = (0, _util.makeCancelable)(Promise.all(promises));
              return _context21.abrupt("return", _this.cancelablePricingPromise.promise.then(function (results) {
                if (pivoting) {
                  var _rowData = (0, _util.getRowData)(results, selectedRow);

                  _this.setState({
                    rowData: _rowData,
                    loading: false
                  });
                } else {
                  return _this.handlePriceResults(results);
                }

                return null;
              }));

            case 31:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21, this);
    }));

    _this.createOptions = function () {
      var skuData = _this.props.skuData;
      var options = _this.state.options;

      if (_this.isSingleSkuEnvironment) {
        var sku = Object.keys(skuData)[0];

        if ((0, _util.isEmptyArray)(options) && _this.ruleSetInfoPerSku[sku]) {
          var allAttributeValues = _this.ruleSetInfoPerSku[sku].allAttributeValues;

          if (allAttributeValues) {
            options = Object.values(allAttributeValues);
          }

          if (!(0, _util.isEmptyArray)(options)) {
            _this.setState({
              options: options
            });
          }
        }
      }
    };

    _this.calculatePriceList =
    /*#__PURE__*/
    function () {
      var _ref24 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee22(onGetAccessToken, isProduction, sku, quantities, defaultQuantity, attributeSelections, fulfillerId, selectedRow, selectedColumns, pivoting) {
        var options, result, _this$ruleSetInfoPerS2, derivedAttributes, ruleSet, pivotKeys, quantityInOptions, filteredAttributeSelections, _this$state8, isQuantityVisible, pivotedQuantity, attributeValue, allAttributeSelections, pivot, values, iterations, evaluationParameters;

        return _regenerator.default.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                options = _this.state.options;

                if (_this.contractsPerSku[sku] && _this.contractsPerSku[sku].relationships) {
                  _context22.next = 6;
                  break;
                }

                _context22.next = 4;
                return (0, _productPrice.getContracts)(sku, onGetAccessToken, isProduction, fulfillerId);

              case 4:
                result = _context22.sent;

                if (result) {
                  _this.contractsPerSku[sku] = result.contracts;
                  _this.listPriceModelsPerSku[sku] = result.listPriceModelInfo;
                }

              case 6:
                if (_this.ruleSetInfoPerSku[sku]) {
                  _context22.next = 9;
                  break;
                }

                _context22.next = 9;
                return _this.getAllAttributeValues();

              case 9:
                _this$ruleSetInfoPerS2 = _this.ruleSetInfoPerSku[sku], derivedAttributes = _this$ruleSetInfoPerS2.derivedAttributes, ruleSet = _this$ruleSetInfoPerS2.ruleSet;
                defaultQuantity = defaultQuantity || _this.getQuantityInAttributes(sku);
                pivotKeys = selectedColumns && selectedColumns.length > 0 ? selectedColumns.map(function (item) {
                  return item.key;
                }) : [];

                if (selectedRow && selectedRow.key) {
                  pivotKeys.push(selectedRow.key);
                }

                attributeSelections = attributeSelections.filter(function (attribute) {
                  return !(attribute.attributeKey.toLowerCase() === 'mcpsku' && attribute.class === 'order');
                }); // Removing Quantity from attributes

                quantityInOptions = options.find(function (option) {
                  return option.key.toLowerCase() === 'quantity';
                });

                if (!(0, _util.isEmptyArray)(options) && quantityInOptions) {
                  attributeSelections = attributeSelections.filter(function (attribute) {
                    return attribute.attributeKey.toLowerCase() !== 'quantity';
                  });
                } // For some skus we need to provide mcpsku as an explicit parameter to bulkEvaluate


                attributeSelections.push({
                  attributeKey: 'McpSku',
                  attributeValue: sku,
                  class: 'order'
                });
                attributeSelections.push({
                  attributeKey: 'McpSku',
                  attributeValue: sku,
                  class: 'tenant'
                }); // Removing derived attributes and pivoted attributes

                filteredAttributeSelections = attributeSelections.filter(function (item) {
                  return (0, _util.isEmptyArray)(pivotKeys.filter(function (key) {
                    return key.toLowerCase() === item.attributeKey.toLowerCase();
                  })) && (0, _util.isEmptyArray)(derivedAttributes.filter(function (key) {
                    return key.toLowerCase() === item.attributeKey.toLowerCase();
                  }));
                });

                if (quantityInOptions && !pivotKeys.find(function (item) {
                  return item.toLowerCase() === 'quantity';
                })) {
                  _this$state8 = _this.state, isQuantityVisible = _this$state8.isQuantityVisible, pivotedQuantity = _this$state8.pivotedQuantity;
                  attributeValue = isQuantityVisible ? pivotedQuantity : defaultQuantity;
                  filteredAttributeSelections.push({
                    attributeKey: 'Quantity',
                    attributeValue: attributeValue,
                    class: 'order'
                  });
                }

                allAttributeSelections = {};
                pivot = selectedRow;

                if (pivot && pivot.key) {
                  values = (0, _util.getValues)(pivot);
                  values.forEach(function (value) {
                    var finalAttributeSelections = (0, _util.deepClone)(filteredAttributeSelections);
                    finalAttributeSelections.push({
                      attributeKey: pivot.key,
                      attributeValue: value,
                      class: pivot.class
                    });
                    allAttributeSelections["|".concat(value)] = finalAttributeSelections;
                  });
                } else {
                  allAttributeSelections['|'] = filteredAttributeSelections;
                }

                if (selectedColumns && selectedColumns.length > 0) {
                  selectedColumns.forEach(function (attribute) {
                    allAttributeSelections = (0, _util.formAttributeMap)(allAttributeSelections, attribute);
                  });
                }

                Object.keys(allAttributeSelections).forEach(function (attributeSelection) {
                  var attributeMap = {};
                  allAttributeSelections[attributeSelection].forEach(function (item) {
                    attributeMap[item.attributeKey] = item.attributeValue;
                  });
                  var result = ruleSet ? (0, _productRulesEngine.validate)(ruleSet, attributeMap) : {
                    isValid: true,
                    finalSelections: []
                  };

                  if (result.isValid === true) {
                    var combinedSelections = {}; // Add final selections from validate response to combined selections

                    result.finalSelections.forEach(function (selection) {
                      combinedSelections[selection.attributeKey.toLowerCase() + selection.class.toLowerCase()] = selection;
                    }); // Add attribute selections to combined selections

                    allAttributeSelections[attributeSelection].forEach(function (selection) {
                      if (selection.attributeKey && selection.class) {
                        combinedSelections[selection.attributeKey.toLowerCase() + selection.class.toLowerCase()] = selection;
                      }
                    });
                    allAttributeSelections[attributeSelection] = Object.values(combinedSelections);
                  } else {
                    allAttributeSelections[attributeSelection] = null; // TODO Add error message that will be displayed in the cell
                  }
                });
                iterations = [];
                Object.values(allAttributeSelections).forEach(function (valueAttributes) {
                  if (valueAttributes) {
                    iterations.push({
                      valueAttributes: valueAttributes
                    });
                  }
                });

                if (!(iterations.length === 0)) {
                  _context22.next = 29;
                  break;
                }

                return _context22.abrupt("return", (0, _util.createEmptyResults)(sku, _this.contractsPerSku[sku], fulfillerId, quantities, pivoting, selectedRow, selectedColumns));

              case 29:
                evaluationParameters = {
                  iterations: iterations
                };
                return _context22.abrupt("return", _this.bulkEvaluateWrapper(onGetAccessToken, isProduction, sku, evaluationParameters, fulfillerId, _this.contractsPerSku[sku], _this.listPriceModelsPerSku[sku], quantities, selectedRow, selectedColumns, pivoting));

              case 31:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      return function (_x29, _x30, _x31, _x32, _x33, _x34, _x35, _x36, _x37, _x38) {
        return _ref24.apply(this, arguments);
      };
    }();

    _this.bulkEvaluateWrapper =
    /*#__PURE__*/
    function () {
      var _ref25 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee23(onGetAccessToken, isProduction, sku, evaluationParameters, fulfillerId, contracts, listPriceModel, quantities, selectedRow, selectedColumns, pivoting) {
        var result, exceptionError, errorResult;
        return _regenerator.default.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.prev = 0;
                _context23.next = 3;
                return (0, _util.bulkEvaluate)(onGetAccessToken, isProduction, sku, evaluationParameters, fulfillerId, contracts, listPriceModel, quantities, selectedRow, selectedColumns, pivoting);

              case 3:
                result = _context23.sent;
                return _context23.abrupt("return", result);

              case 7:
                _context23.prev = 7;
                _context23.t0 = _context23["catch"](0);
                exceptionError = _this.createError('Error', _this.getErrorMessage(_context23.t0), 'Error');
                errorResult = {};

                if (!(_context23.t0.message === _productPrice.NO_CONTRACTS_OR_LISTPRICE_MESSAGE)) {
                  _context23.next = 17;
                  break;
                }

                _context23.next = 14;
                return _this.handleNoResults(sku);

              case 14:
                errorResult[sku] = _context23.sent;
                _context23.next = 30;
                break;

              case 17:
                if (!(_context23.t0.status === 404)) {
                  _context23.next = 24;
                  break;
                }

                _context23.next = 20;
                return _this.handleNoResults(sku);

              case 20:
                errorResult[sku] = _context23.sent;

                _this.setError(exceptionError);

                _context23.next = 30;
                break;

              case 24:
                if (!(_context23.t0.status === 400 || _context23.t0.status === 500)) {
                  _context23.next = 28;
                  break;
                }

                return _context23.abrupt("return", (0, _util.createEmptyResults)(sku, contracts, fulfillerId, quantities, pivoting, selectedRow, selectedColumns));

              case 28:
                _this.setError(exceptionError);

                errorResult[sku] = exceptionError;

              case 30:
                return _context23.abrupt("return", errorResult);

              case 31:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this, [[0, 7]]);
      }));

      return function (_x39, _x40, _x41, _x42, _x43, _x44, _x45, _x46, _x47, _x48, _x49) {
        return _ref25.apply(this, arguments);
      };
    }();

    _this.resetQuantities = function () {
      if (_this.isSingleSkuEnvironment) {
        _this.setState({
          quantityBreaks: _this.getInitialQuantities()
        }, function () {
          return _this.calculatePricesAndShipping();
        });

        _this.saveCustomQuantities();
      } else {
        _this.populatePricingGrid();
      }
    };

    _this.calculatePricesAndShipping = function () {
      Promise.all([_this.calculate(), _this.fetchShippingValues()]).then(function (data) {
        return _this.copyShippingData(data);
      });
    };

    _this.populatePricingGrid = function () {
      _this.populateQuantities().then(function (quantityBreaks) {
        return _this.setState({
          quantityBreaks: quantityBreaks
        },
        /*#__PURE__*/
        (0, _asyncToGenerator2.default)(
        /*#__PURE__*/
        _regenerator.default.mark(function _callee24() {
          return _regenerator.default.wrap(function _callee24$(_context24) {
            while (1) {
              switch (_context24.prev = _context24.next) {
                case 0:
                  _this.setQuantitiesInOptions();

                  Promise.all([_this.getSellers(), _this.fetchShippingValues()]).then(function (data) {
                    return _this.copyShippingData(data);
                  });

                case 2:
                case "end":
                  return _context24.stop();
              }
            }
          }, _callee24, this);
        })));
      });
    };

    _this.deleteQuantity = function (index) {
      var quantityBreaks = _this.state.quantityBreaks;

      if (index >= 0 && index < quantityBreaks.length) {
        var newQuantities = (0, _toConsumableArray2.default)(quantityBreaks);
        newQuantities.splice(index, 1);

        _this.setState({
          quantityBreaks: newQuantities
        }, function () {
          _this.saveCustomQuantities();

          _this.setStateToNotifyUserOnce();
        });
      }
    };

    _this.addQuantities = function (newQuantities) {
      if (newQuantities && newQuantities.length) {
        var quantityBreaks = _this.state.quantityBreaks;

        _this.setState({
          quantityBreaks: (0, _sortBy.default)((0, _union.default)(newQuantities, quantityBreaks))
        }, function () {
          _this.setStateToNotifyUserOnce();

          _this.calculatePricesAndShipping();

          _this.saveCustomQuantities();
        });
      }
    };

    _this.saveQuantitiesFromFilterOptions = function (quantityBreaks) {
      _this.setState({
        quantityBreaks: quantityBreaks
      }, function () {
        return _this.saveCustomQuantities();
      });
    };

    _this.saveCustomQuantities =
    /*#__PURE__*/
    (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee25() {
      var _this$props7, skuData, onGetAccessToken, productCategoryId, quantityBreaks;

      return _regenerator.default.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              if (_this.isSingleSkuEnvironment) {
                _context25.next = 2;
                break;
              }

              return _context25.abrupt("return");

            case 2:
              _this.setQuantitiesInOptions();

              _this$props7 = _this.props, skuData = _this$props7.skuData, onGetAccessToken = _this$props7.onGetAccessToken;
              _context25.prev = 4;
              _context25.next = 7;
              return _this.getProductCategoryId(Object.keys(skuData)[0], onGetAccessToken);

            case 7:
              productCategoryId = _context25.sent;
              quantityBreaks = _this.state.quantityBreaks;
              (0, _customQuantities.setCustomSettings)(_this.getCustomQuantityId(productCategoryId), {
                quantities: quantityBreaks
              }, onGetAccessToken);
              _context25.next = 15;
              break;

            case 12:
              _context25.prev = 12;
              _context25.t0 = _context25["catch"](4); // Swallowing Exception

              _this.logger.error("Unable to save custom quantities for the sku [".concat(skuData, "] following is the error [").concat(_context25.t0, "]"), _this.componentName);

            case 15:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25, this, [[4, 12]]);
    }));

    _this.modifyResults = function (hasListPriceArray, modifiedResults, allMerchants) {
      var allResults = [];
      var numberOfColumns = _this.props.numberOfColumns;
      var _this$props8 = _this.props,
          isListPriceFixed = _this$props8.isListPriceFixed,
          showListPriceFirst = _this$props8.showListPriceFirst;
      var numberOfSkus = Object.keys(_this.props.skuData).length;

      if (_this.isSingleSkuEnvironment && modifiedResults && modifiedResults[0]) {
        if (!modifiedResults[0].error) {
          var availableColumns = Object.keys(modifiedResults[0]).length;
          numberOfColumns = availableColumns < _this.props.numberOfColumns ? availableColumns : numberOfColumns;
          var filteredData = {}; // if we have isListPriceFixed prop true, filteredData will contain
          // all items except list price

          if (numberOfColumns > 1 && isListPriceFixed && showListPriceFirst) {
            Object.keys(modifiedResults[0]).forEach(function (key) {
              if (key !== _util.LIST_PRICE) {
                filteredData[key] = modifiedResults[0][key];
              }
            });
          }

          var filterDataSize = Object.keys(filteredData).length;

          for (var i = 0; i < numberOfColumns; i += 1) {
            if (filterDataSize && i > 0) {
              allResults.push({
                data: filteredData
              });
            } else {
              allResults.push({
                data: modifiedResults[0]
              });
            }
          }
        }
      } else {
        for (var _i2 = 0; _i2 < numberOfSkus; _i2 += 1) {
          if (modifiedResults[_i2] && modifiedResults[_i2].error) {
            allResults.push({
              error: modifiedResults[_i2].error
            });
          } else {
            allResults.push({
              data: modifiedResults[_i2]
            });
          }
        }
      }

      return (0, _util.addShowToData)(allResults, hasListPriceArray, allMerchants, numberOfSkus, numberOfColumns, showListPriceFirst, _this.isSingleSkuEnvironment);
    };

    _this.handlePriceResults = function (results) {
      var allMerchants = [];
      var hasListPriceArray = [];
      var modifiedResults = []; // Converts results from api which is in form of array of objects into array
      // of maps where keys is buyer

      results.forEach(function (resultsPerSku) {
        var modifiedResultsPerSku = {};
        var merchants = [];
        var hasListPrice = false;

        if (Array.isArray(resultsPerSku)) {
          resultsPerSku.forEach(function (result) {
            var buyerId = null;

            if (result && result.buyer && result.buyer.buyerId) {
              buyerId = result.buyer.buyerId;
            }

            if (buyerId === _util.LIST_PRICE) {
              hasListPrice = true;
            } else {
              merchants.push(buyerId);
            }

            modifiedResultsPerSku[buyerId] = result;
          });
          hasListPriceArray.push(hasListPrice);
          modifiedResults.push(modifiedResultsPerSku);
          allMerchants.push(merchants);
        } else {
          hasListPriceArray.push(null);
          modifiedResults.push(resultsPerSku);
          allMerchants.push(null);
        }
      });
      results = _this.modifyResults(hasListPriceArray, modifiedResults, allMerchants);

      _this.setState({
        loading: false,
        results: results
      });

      return results;
    };

    _this.handleNoResults =
    /*#__PURE__*/
    function () {
      var _ref28 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee26(sku) {
        var _this$props9, onGetAccessToken, isProduction, errorMessage, newErrorMessage, selectVariantMessage;

        return _regenerator.default.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _this.logger.error("Pricing is not set for the sku [".concat(sku, "]"), _this.componentName);

                _this$props9 = _this.props, onGetAccessToken = _this$props9.onGetAccessToken, isProduction = _this$props9.isProduction;
                errorMessage = _this.createError('Error', "Pricing hasn't been set for this SKU. Contact the seller for more information.", 'Error');
                _context26.next = 5;
                return (0, _introduction.getProductDetails)(onGetAccessToken, sku).then(function (res) {
                  return res.externalFulfillerId;
                }).then(function (fulfillerId) {
                  return (0, _coam.canCreatePriceModels)(onGetAccessToken, fulfillerId);
                }).then(function (hasPermission) {
                  if (hasPermission) {
                    errorMessage = _this.createError(_react.default.createElement("div", null, _react.default.createElement("a", {
                      href: "https://".concat(!isProduction ? 'stg-' : '', "pricingmanager.financialflows.cimpress.io"),
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, "Set up pricing")), 'Pricing hasn’t been set for this SKU.', 'Error');
                  }

                  _this.setError(errorMessage);

                  return errorMessage;
                }).catch(function () {
                  _this.setError(errorMessage);

                  return errorMessage;
                }).catch(function () {
                  _this.logger.error("Unable to fetch details for the given sku [".concat(sku, "]."), _this.componentName);
                });

              case 5:
                newErrorMessage = _context26.sent;
                _context26.next = 8;
                return _this.getSelectVariantMessage(sku);

              case 8:
                selectVariantMessage = _context26.sent;
                return _context26.abrupt("return", selectVariantMessage || newErrorMessage || errorMessage);

              case 10:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      return function (_x50) {
        return _ref28.apply(this, arguments);
      };
    }();

    _this.displayErrorMessage = function (results) {
      var errorMessage = 'Shipping cost is not configured for weight of these quantities.';

      _this.logger.error("Shipping cost is not configured for weight of these quantities ".concat(_this.state.quantityBreaks));

      var note = '';

      if (results) {
        var index = results.findIndex(function (item) {
          return !item;
        });

        if (index >= 1) {
          errorMessage = "Shipping cost is not available for quantities above ".concat(_this.state.quantityBreaks[index], ", shipping cost is not configured for weight of these quantities.");
          note = 'Note: Shipping cost estimation based on single shipment.';
          return {
            errorMessage: errorMessage,
            note: note
          };
        } else if (index === 0) {
          return {
            errorMessage: errorMessage,
            note: note
          };
        }
      }

      return null;
    };

    _this.cancelShippingPromises = function () {
      if (_this.cancelableShippingPromise) {
        _this.cancelableShippingPromise.cancel();

        _this.cancelableShippingPromise = null;
      }
    };

    _this.togglePivoting = function () {
      var pivoting = _this.state.pivoting;
      pivoting = !pivoting;

      if (pivoting) {
        _this.setState({
          pivoting: pivoting,
          headers: null
        });
      } else {
        _this.setState({
          pivoting: pivoting
        });
      }
    };

    _this.createHeadersWithDropDown = function (selectedRow, selectedColumns, contracts, sku) {
      var headers = {};
      var showDropdown = true;
      contracts.forEach(function (buyerId) {
        var _headers$buyerId;

        headers[buyerId] = [];

        if (selectedRow) {
          var key = selectedRow.key;
          headers[buyerId].push({
            name: key,
            value: key
          });
        }

        var prefix = "".concat(sku, "|").concat(buyerId, "|");
        var columnHeaders = (0, _util.createSubHeaders)(prefix, selectedColumns, 0);

        (_headers$buyerId = headers[buyerId]).push.apply(_headers$buyerId, (0, _toConsumableArray2.default)(columnHeaders));
      });
      Object.keys(headers).forEach(function (buyer) {
        headers[buyer] = Object.values(headers[buyer]);
      });

      _this.setState({
        headers: headers,
        showDropdown: showDropdown
      });
    };

    _this.createHeadersWithoutDropdown = function (selectedRow, selectedColumns, contracts, sku) {
      var headers = [];
      var showDropdown = false;

      if (selectedRow) {
        var key = selectedRow.key;
        headers.push({
          name: key,
          value: key
        });
      }

      contracts.forEach(function (buyerId) {
        var prefix = "".concat(sku, "|").concat(buyerId, "|");
        headers.push({
          name: buyerId,
          value: "".concat(prefix, "|")
        });
      });

      _this.setState({
        headers: headers,
        showDropdown: showDropdown
      });
    };

    _this.createHeaders = function (selectedRow, selectedColumns) {
      if (!selectedRow && (0, _util.isEmptyArray)(selectedColumns)) {
        return;
      }

      var skuData = _this.props.skuData;
      var sku = Object.keys(skuData)[0];
      var contracts = [];

      if (_this.listPriceModelsPerSku && _this.listPriceModelsPerSku[sku] && _this.listPriceModelsPerSku[sku].revisionId) {
        contracts.push(_util.LIST_PRICE);
      }

      if (_this.contractsPerSku[sku] && _this.contractsPerSku[sku].length > 0) {
        _this.contractsPerSku[sku].forEach(function (contract) {
          if (contract && contract.buyer && contract.buyer.buyerId) {
            contracts.push(contract.buyer.buyerId);
          }
        });
      }

      if ((0, _util.isEmptyArray)(selectedColumns)) {
        _this.createHeadersWithoutDropdown(selectedRow, selectedColumns, contracts, sku);
      } else {
        _this.createHeadersWithDropDown(selectedRow, selectedColumns, contracts, sku);
      }
    };

    _this.changePivotLayoutState = function (newState) {
      _this.setState({
        pivotLayoutState: newState
      });
    };

    _this.componentName = 'PricingGrid';
    _this.state = _this.getInitialState();

    if (Object.keys(_props.skuData).length > 1) {
      _this.isSingleSkuEnvironment = false;
    }

    _this.logger = (0, _logger.getLoggerForToken)(_props.onGetAccessToken);

    _this.logger.info('Pricing Grid in use', _this.componentName);

    return _this;
  }

  (0, _createClass2.default)(PricingGrid, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadInitialData();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelShippingPromises();
    }
  }, {
    key: "getProductCategoryId",
    value: function () {
      var _getProductCategoryId2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee27(sku, onGetAccessToken) {
        var refresh,
            _args27 = arguments;
        return _regenerator.default.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                refresh = _args27.length > 2 && _args27[2] !== undefined ? _args27[2] : false;

                if (!this.productCategoryIds[sku] || refresh) {
                  this.productCategoryIds[sku] = (0, _productCategory.getProductCategoryId)(sku, onGetAccessToken);
                }

                return _context27.abrupt("return", this.productCategoryIds[sku]);

              case 3:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function getProductCategoryId(_x51, _x52) {
        return _getProductCategoryId2.apply(this, arguments);
      }

      return getProductCategoryId;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state9 = this.state,
          loading = _this$state9.loading,
          errorMessage = _this$state9.errorMessage,
          results = _this$state9.results,
          quantityBreaks = _this$state9.quantityBreaks,
          fulfillers = _this$state9.fulfillers,
          selectedFulfiller = _this$state9.selectedFulfiller,
          priceExplorerUserSettings = _this$state9.priceExplorerUserSettings,
          shipmentConfiguration = _this$state9.shipmentConfiguration,
          pivoting = _this$state9.pivoting,
          options = _this$state9.options,
          priceMode = _this$state9.priceMode,
          headers = _this$state9.headers,
          rowData = _this$state9.rowData,
          showDropdown = _this$state9.showDropdown;
      var _this$props10 = this.props,
          widthOfPrices = _this$props10.widthOfPrices,
          widthOfQuantity = _this$props10.widthOfQuantity,
          parentComponent = _this$props10.parentComponent,
          skuData = _this$props10.skuData,
          showPriceModeToggle = _this$props10.showPriceModeToggle,
          showPivotingToggle = _this$props10.showPivotingToggle;
      var pivotingToggleDisabled = true;

      if (!parentComponent) {
        var newErrorMessage = this.createError('Error', 'Provide parentComponent in props', 'Error');
        return _react.default.createElement(_PricingError.default, {
          message: newErrorMessage
        });
      }

      if (errorMessage) {
        return _react.default.createElement(_PricingError.default, {
          message: errorMessage
        });
      }

      if (loading) {
        return _react.default.createElement(_Spinner.default, {
          className: "flex-center"
        });
      }

      var defaultQuantity;
      var pivotingResults;

      if (showPivotingToggle) {
        defaultQuantity = this.getQuantityInAttributesOrMoq();
        pivotingResults = {
          headers: headers,
          rowData: rowData
        };
        var quantity = options.find(function (item) {
          return item.key.toLowerCase() === 'quantity';
        });

        if (quantity) {
          quantity.defaults = quantityBreaks;
          quantity.selectedValues = quantityBreaks;
        }

        if (!((0, _util.isEmptyArray)(options) || quantity !== null && options.length && options.length === 1)) {
          pivotingToggleDisabled = false;
        }
      }

      var fulfillerSelector = null;

      if (this.isSingleSkuEnvironment) {
        var sku = Object.keys(skuData)[0];
        var sellerId = skuData[sku].sellerId;
        fulfillerSelector = !sellerId ? _react.default.createElement(_FulfillerSelector.default, {
          fulfillers: fulfillers,
          selectedFulfiller: selectedFulfiller,
          onFulfillerSelect: this.onFulfillerSelect
        }) : null;
      }

      return _react.default.createElement("div", {
        style: {
          width: 'max-content'
        }
      }, _react.default.createElement("div", {
        className: "row"
      }, showPriceModeToggle ? _react.default.createElement("div", {
        className: "col-md-5 pricing-details-toggle",
        style: {
          width: 'fit-content',
          marginLeft: '-15px'
        }
      }, _react.default.createElement(_PriceModeToggle.default, {
        priceMode: priceMode,
        setPriceMode: this.setPriceMode
      })) : null, showPivotingToggle && !(0, _util.isEmptyArray)(options) ? _react.default.createElement("div", {
        className: " col-md-4 pivot-toggle"
      }, pivotingToggleDisabled ? _react.default.createElement(_reactComponents.Tooltip, {
        direction: "right",
        contents: "The selected sku doesn't have enough attributes to enable pivoting"
      }, _react.default.createElement(_reactComponents.Toggle, {
        on: pivoting,
        onClick: this.togglePivoting,
        disabled: pivotingToggleDisabled,
        onText: "Pivot On",
        offText: "Pivot Off"
      })) : _react.default.createElement(_reactComponents.Toggle, {
        on: pivoting,
        onClick: this.togglePivoting,
        disabled: pivotingToggleDisabled,
        onText: "Pivot On",
        offText: "Pivot Off"
      })) : null), fulfillerSelector, pivoting && options ? _react.default.createElement(_PivotLayout.default, {
        results: pivotingResults,
        options: options,
        quantities: quantityBreaks,
        priceMode: priceMode,
        onUpdateSelectedRowColumns: this.onUpdateSelectedRowColumns,
        showPivotingControls: pivoting,
        defaultQuantity: defaultQuantity,
        onQuantityChange: this.onQuantityChange,
        saveQuantities: this.saveQuantitiesFromFilterOptions,
        showDropdown: showDropdown,
        onQuantityVisibilityChange: this.onQuantityVisibilityChange,
        pivotLayoutState: this.state.pivotLayoutState,
        changePivotLayoutState: this.changePivotLayoutState
      }) : _react.default.createElement(_PricingGridLayout.default, {
        results: results,
        quantities: quantityBreaks,
        addQuantities: this.addQuantities,
        deleteQuantity: this.deleteQuantity,
        resetQuantities: this.resetQuantities,
        userHasBeenNotifiedOfQuantityChange: this.userHasBeenNotifiedOfQuantityChange,
        priceMode: priceMode,
        widthOfPrices: widthOfPrices,
        widthOfQuantity: widthOfQuantity,
        priceExplorerUserSettings: priceExplorerUserSettings,
        onShippingSubmit: this.onShippingSubmit,
        shipmentConfiguration: shipmentConfiguration
      }));
    }
  }]);
  return PricingGrid;
}(_react.Component);

exports.default = PricingGrid;
PricingGrid.defaultProps = {
  includeDefaultQuantities: true,
  numberOfColumns: 4,
  showListPriceFirst: true,
  isListPriceFixed: true,
  showPivotingToggle: false,
  showPriceModeToggle: false
};